import { render } from "./IpAddressRangeForm.vue?vue&type=template&id=b2a40bea&scoped=true"
import script from "./IpAddressRangeForm.vue?vue&type=script&lang=js"
export * from "./IpAddressRangeForm.vue?vue&type=script&lang=js"

import "./IpAddressRangeForm.vue?vue&type=style&index=0&id=b2a40bea&scoped=true&lang=less"

import exportComponent from "/home/biktorgj/Projects/Linube Cloud/Server_and_UI/ui-prod-4.22/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2a40bea"]])

export default __exports__